import { createSlice } from '@reduxjs/toolkit';
import { IAccount } from '@wot/typings';

interface IInitalState {
  tutor: IAccount | null,
  error: string,
  loading: boolean
}

const initalState: IInitalState = {
  tutor: null,
  error: "",
  loading: false
}



const authSlice = createSlice({
  name: "authReducer",
  initialState: initalState,
  reducers: {
    login: (state, { payload }) => {
      state.tutor = payload;
    },

  },

  extraReducers(builder) {

  },
})


export const { login } = authSlice.actions


export default authSlice.reducer